import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Navbar from "../../components/Navbar";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ContactSales = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }, []);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    // TODO: Implement your form submission logic here
    toast.success("Message sent successfully! We'll get back to you soon.");

    // Reset form fields
    setFormData({
      name: "",
      email: "",
      phone: "",
      company: "",
      message: "",
    });
  } catch (error) {
    toast.error("Failed to send message. Please try again.");
  }
};

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Navbar />
      
      {/* Back Button */}
      <motion.div
        initial={{ opacity: 0, x: -10 }}
        animate={{ opacity: 1, x: 0 }}
        className="relative px-4 pt-6 mx-auto max-w-7xl sm:px-6 lg:px-8"
      >
        <button
          onClick={() => navigate(-1)}
          className="flex items-center px-4 py-2 text-gray-600 transition-colors bg-white rounded-full shadow-md hover:text-[#FF6C6C] group"
        >
          <svg
            className="mr-2 w-5 h-5 transition-transform group-hover:-translate-x-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          Back
        </button>
      </motion.div>

      {/* Hero Section with Background Pattern */}
      <div className="overflow-hidden relative">
        <div className="absolute inset-0 opacity-5 bg-grid-pattern"></div>
        <div className="relative px-4 py-8 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <motion.div
              initial={{ scale: 0.95 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5 }}
              className="inline-block px-6 py-1 mb-6 text-sm font-semibold text-[#FF6C6C] bg-[#FF6C6C]/10 rounded-full"
            >
              Platinum Solutions
            </motion.div>
              <h1 className="mb-6 text-5xl font-bold text-gray-900 lg:text-6xl leading-tight">
               Let's Build Something
               <span className="block mt-2 mb-3 text-transparent bg-clip-text bg-gradient-to-r from-[#FF6C6C] to-[#FF9494] leading-tight">
                 Great Together
               </span>
              </h1> 
            <p className="mx-auto mb-8 max-w-2xl text-xl text-gray-600">
              Get in touch with our platinum team to create a tailored solution that perfectly fits your business needs
            </p>
          </motion.div>
        </div>
      </div>

      {/* Main Content */}
      <div className="px-4 py-16 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-2">
          {/* Left Column - Contact Information */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="space-y-8"
          >
            <div className="p-8 bg-white rounded-2xl shadow-xl">
              <h3 className="mb-6 text-2xl font-bold text-gray-900">
                Ways to Connect
              </h3>
              <div className="space-y-6">
                <motion.div
                  whileHover={{ scale: 1.02 }}
                  className="flex items-center p-4 rounded-xl border border-gray-100 transition-colors hover:bg-gray-50"
                >
                  <div className="flex items-center justify-center w-12 h-12 bg-[#FF6C6C]/10 rounded-full">
                    <svg className="w-6 h-6 text-[#FF6C6C]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <h4 className="text-sm font-medium text-gray-500">Call Us</h4>
                    <a href="tel:+233000000000" className="text-lg font-semibold text-gray-900 hover:text-[#FF6C6C]">
                      + (233) 000-000
                    </a>
                  </div>
                </motion.div>

                <motion.div
                  whileHover={{ scale: 1.02 }}
                  className="flex items-center p-4 rounded-xl border border-gray-100 transition-colors hover:bg-gray-50"
                >
                  <div className="flex items-center justify-center w-12 h-12 bg-[#FF6C6C]/10 rounded-full">
                    <svg className="w-6 h-6 text-[#FF6C6C]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <h4 className="text-sm font-medium text-gray-500">Email Us</h4>
                    <a href="mailto:sales@dealboxx.com" className="text-lg font-semibold text-gray-900 hover:text-[#FF6C6C]">
                      sales@dealboxx.com
                    </a>
                  </div>
                </motion.div>
              </div>
            </div>

            <div className="p-8 bg-white rounded-2xl shadow-xl">
              <h3 className="mb-6 text-2xl font-bold text-gray-900">
                Platinum Benefits
              </h3>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                {[
                  {
                    title: "Dedicated Support",
                    description: "24/7 priority assistance from our expert team"
                  },
                  {
                    title: "Custom Integration",
                    description: "Tailored solutions for your specific needs"
                  },
                  {
                    title: "Advanced Security",
                    description: "Enterprise-grade security measures"
                  },
                  {
                    title: "Flexible Billing",
                    description: "Customized payment terms that work for you"
                  }
                ].map((benefit, index) => (
                  <motion.div
                    key={index}
                    whileHover={{ scale: 1.02 }}
                    className="p-4 rounded-xl border border-gray-100 transition-colors hover:bg-gray-50"
                  >
                    <h4 className="mb-2 text-lg font-semibold text-gray-900">{benefit.title}</h4>
                    <p className="text-sm text-gray-600">{benefit.description}</p>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>

          {/* Right Column - Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            className="relative"
          >
            <div className="absolute inset-0 transform -rotate-6 bg-gradient-to-r from-[#FF6C6C] to-[#FF9494] rounded-2xl opacity-10"></div>
            <div className="relative p-8 bg-white rounded-2xl shadow-xl">
              <h3 className="mb-6 text-2xl font-bold text-gray-900">
                Tell Us About Your Business
              </h3>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-700">Full Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 transition-colors border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6C6C]/20 focus:border-[#FF6C6C]"
                      placeholder="John Doe"
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-700">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 transition-colors border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6C6C]/20 focus:border-[#FF6C6C]"
                      placeholder="john@company.com"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-700">Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 transition-colors border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6C6C]/20 focus:border-[#FF6C6C]"
                      placeholder="+ (233) 000-000"
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-700">Company Name</label>
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 transition-colors border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6C6C]/20 focus:border-[#FF6C6C]"
                      placeholder="Your Company"
                    />
                  </div>
                </div>

                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-700">Details</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="4"
                    className="w-full px-4 py-3 transition-colors border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6C6C]/20 focus:border-[#FF6C6C]"
                    placeholder="Tell us about your requirements..."
                  ></textarea>
                </div>

                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  type="submit"
                  className="w-full px-8 py-4 text-lg font-semibold text-white transition-all bg-gradient-to-r from-[#FF6C6C] to-[#FF9494] rounded-lg shadow-lg hover:shadow-xl"
                >
                  Send Message
                </motion.button>
                <p className="text-sm text-center text-gray-500">
                  We'll get back to you within 24 hours
                </p>
              </form>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ContactSales; 